import { inject, Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Message } from '../interfaces/message';
import { Observable } from 'rxjs';
import { WebSocketService } from './web-socket.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  http = inject(HttpClient);
  webSocketService = inject(WebSocketService);

  constructor () { };

  // all: channel
  // notification: channel, raceId (from && to)
  // player: channel, userid/userId2 ((from && to) || (to && from))
  // race: channel, raceid/raceId2 ((from && to) || (to && from))
  // negotiation: channel, negotiationId
  // encounter: channel, encounterId

  buildQueryString (campaignId: string, channel: string, id: string, id2: string, page: number, offset: number) {
    let queryString = '?campaignId=' + campaignId + '&channel=' + channel;
    switch (channel) {
      // Notification messages should not come through here!
      case 'Notification':
        queryString += '&id=' + id;
        break;
      case 'All':
        break;
      case 'Player':
        queryString += '&id=' + id + '&id2=' + id2;
        break;
      case 'Race':
        queryString += '&id=' + id + '&id2=' + id2;
        break;
      case 'Negotiation':
        queryString += '&id=' + id;
        break;
      case 'Encounter':
        queryString += '&id=' + id;
        break;
      default:
    };
    if (page) {
      queryString += '&page=' + page;
    }
    if (offset) {
      queryString += '&offset=' + offset;
    }
    return queryString;
  };

  getMessages (campaignId: string, channel: string, id: string, id2: string, page: number, offset: number = 0): Observable<Message[]> {
    let queryString = this.buildQueryString(campaignId, channel, id, id2, page, offset);
    return this.http.get<Message[]>('/api/messages/array' + queryString);
  };

  // let messageData = {
  //     campaignId: campaignId,
  //     channel: channel,
  //     message: messageText,
  //     userIdFrom: userId,
  //     userIdTo: userIdTo,
  //     raceIdFrom: raceIdFrom,
  //     raceIdTo: raceIdTo,
  //     identity: identity
  // };

  buildMessageTemplate (campaignId, channel, messageText, userIdFrom = null, userIdTo = null, raceIdFrom = null, raceIdTo = null, negotiationId = null, encounterId = null) {
    let messageData: Message = {
      campaignId: campaignId,
      channel: channel,
      message: messageText
    };
    if (userIdFrom) {
      messageData.userIdFrom = userIdFrom;
    }
    if (userIdTo) {
      messageData.userIdTo = userIdTo;
    }
    if (raceIdFrom) {
      messageData.raceIdFrom = raceIdFrom;
    }
    if (raceIdTo) {
      messageData.raceIdTo = raceIdTo;
    }
    if (negotiationId) {
      messageData.negotiationId = negotiationId;
    }
    if (encounterId) {
      messageData.encounterId = encounterId;
    }
    return messageData;
  };

  sendMessage (messageData) {
    this.webSocketService.sendMessage(messageData);
  };

  saveMessage (messageData: Message) {
    return this.http.post('/api/messages/' + messageData.userIdFrom + '/' + messageData.campaignId + '/' + messageData.channel, messageData);
  };
};
